import controller from './thing-status.controller';

const template = require('./thing-status.html');

export default {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-status/thing-status.component.js